import { Platform } from 'click-types';
import { defaultPathComponent } from '@common/constants/shared';
import { ILabel } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import {
  getActions,
  getItemListClick,
} from '@common/utils/handleActions/func/helps';
import { isEmpty } from 'lodash';
import React, { FC, useMemo } from 'react';
import { Text, View } from 'react-native';
import createStyles from './style';
import { useAppSelector } from '@common/redux/hooks';
import { appInfoSelector } from '@common/redux/selectors/app';

const CusLabel: FC<ILabel> = (attrs) => {
  const appInfo = useAppSelector(appInfoSelector);
  const text = getValueBindingComponent(
    attrs,
    defaultPathComponent[attrs.type]
  );

  // For responsive, I don't known why the children is a list of objects, so we need to convert it to a string
  const childText = useMemo(() => {
    if (appInfo?.platform === Platform.RESPONSIVE) {
      if (Array.isArray(attrs.children) && attrs.children.length > 0) {
        const _childText = attrs.children
          .map((child) => child?.toString())
          .join('');
        return _childText === '[object Object]' ? '' : _childText;
      }
      return '';
    }
    return (attrs.children?.toString() as string) || '';
  }, [attrs.children, appInfo?.platform]);

  const styles = createStyles(attrs);
  const handlePress = (event: any) => {
    event.preventDefault();
    let arrayAction = getActions(attrs.actions);
    attrs.onPress &&
      attrs.onPress(arrayAction, {
        itemListClick: getItemListClick(attrs?.record),
      });
  };
  return (
    <View style={styles.container} nativeID={`label-${attrs.id}`}>
      <Text
        style={styles.text}
        numberOfLines={attrs.multiline ? 0 : 1}
        {...(!isEmpty(attrs.actions) ? { onPress: handlePress } : {})}
      >
        {text.replace(/\n$/, '')}
        {childText}
      </Text>
    </View>
  );
};

export default CusLabel;
